import { apiClient } from './client'
import type { CityAreaOption, CityPath } from '@/types/city'

export const citiesApi = {
  /**
   * 根据 parent_id 获取子级区域列表
   * parent_id=0 返回所有省份
   */
  list: async (parentId: number): Promise<CityAreaOption[]> => {
    const response = await apiClient.get<CityAreaOption[]>(
      `/cities?parent_id=${parentId}`
    )
    return response.data
  },

  /**
   * 根据 ID 获取完整省市区路径（编辑回显用）
   */
  getPath: async (id: number): Promise<CityPath> => {
    const response = await apiClient.get<CityPath>(`/cities/${id}/path`)
    return response.data
  },
}
